import * as ContextTypes from './ContextTypes';

export default (state: ContextTypes.IContextState, action: ContextTypes.IContextAction) => {
  if (action.type === ContextTypes.HIDE_OPEN_IN_APP_MSG) {
    return { ...state, isOpenInAppMessageOpen: false };
  }

  return state;
};
